import React from 'react';
import {
  Globe,
  Lock,
  Layers,
  Code2,
} from 'lucide-react';
import FeatureSection from './FeatureSection';

const features = [
  {
    title: 'Public Chatting (Default)',
    desc: 'Any visitor can start a conversation with your AI agent across every connected channel — no friction, no logins.',
    icon: <Globe size={20} />,
    bg: '#e0f7fe',
    color: '#06b6ec',
  },
  {
    title: 'Private Channel Access',
    desc: 'Restrict AI responses to only authorised account numbers or specific users — perfect for VIP support.',
    icon: <Lock size={20} />,
    bg: '#ede9fe',
    color: '#8b5cf6',
    badge: 'Available on Enterprise Plan',
  },
  {
    title: 'Unified Integration Hub',
    desc: 'Centralise Telegram, Instagram, Facebook, WhatsApp (Official WABA + QR Scan) and Web Chat in one place.',
    icon: <Layers size={20} />,
    bg: '#dcfce7',
    color: '#22c55e',
  },
  {
    title: 'Custom Web Chat Widget',
    desc: 'Copy-and-paste snippet with customisable colours, icons and welcome messages — live in minutes.',
    icon: <Code2 size={20} />,
    bg: '#ffedd5',
    color: '#f97316',
  },
];

export default function Omnichannel() {
  return (
    <div id="features">
      <FeatureSection
        id="omnichannel"
        eyebrow="Omnichannel · Privacy"
        title="One inbox for every conversation"
        description="Meet your customers wherever they are — and decide exactly who the AI talks to. Public for everyone, or locked-down for authorised accounts only."
        features={features}
        variant="light"
      />
    </div>
  );
}
